import React, { useCallback } from 'react';

import ArrowRightIcon from '@atlaskit/icon/core/arrow-right';
import TextWrapIcon from '@atlaskit/icon/core/text-wrap';
import {
	ConfigFieldDropdown,
	type FieldOption,
	type RenderVariant,
} from '@atlassian/company-hub-common';

import { CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE } from '../../../../constants';
import type { UpdateMainFormFieldType } from '../../../../controllers/use-cards-extension-parameters-and-actions/types';
import { type CardsExtensionParameters, Orientation } from '../../../../types';

import { messages } from './messages';

const orientationOptions: FieldOption<Orientation>[] = [
	{
		icon: ArrowRightIcon,
		label: messages.rowItemLabel,
		description: messages.rowItemDescription,
		value: Orientation.ROW,
	},
	{
		icon: TextWrapIcon,
		label: messages.stackedItemLabel,
		description: messages.stackedItemDescription,
		value: Orientation.STACKED,
	},
];

const defaultOption = orientationOptions[0];

type OrientationFieldProps = {
	orientation: CardsExtensionParameters['orientation'];
	renderVariant: RenderVariant;
	showUpdatedStyles?: boolean;
	updateMainFormField: UpdateMainFormFieldType;
};

export const OrientationField = ({
	orientation,
	renderVariant,
	updateMainFormField,
	showUpdatedStyles,
}: OrientationFieldProps): React.JSX.Element => {
	const selectedOption =
		orientationOptions.find(({ value }) => value === orientation) || defaultOption;

	const handleSelect = useCallback(
		(selectedLabel: FieldOption<Orientation>) => {
			updateMainFormField({ orientation: selectedLabel.value });
		},
		[updateMainFormField],
	);

	return (
		<ConfigFieldDropdown<Orientation>
			fieldType="orientation"
			label={messages.displayAsLabel}
			onSelect={handleSelect}
			options={orientationOptions}
			renderVariant={renderVariant}
			selectedOption={selectedOption}
			showUpdatedStyles={showUpdatedStyles}
			source={CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE}
		/>
	);
};
